module.exports = __webpack_public_path__ + "static/media/7-pin.7cd7454f.svg";